import {
  DEFAULT_LOCALE,
  messages,
  type SupportedLocale,
  updateLocale,
} from '@/plugins/i18n.plugin';

function getOfficeDisplayLanguage(): string | null {
  if (typeof Office === 'undefined') {
    return null;
  }

  return Office.context?.displayLanguage || null;
}

function normalizeLanguageTag(languageTag: string): string {
  return languageTag.trim().replace('_', '-').toLowerCase();
}

export function resolveSupportedLocale(
  languageTag?: string | null
): SupportedLocale {
  if (!languageTag) {
    return DEFAULT_LOCALE;
  }

  const normalized = normalizeLanguageTag(languageTag);
  const exactMatch = Object.keys(messages).find(
    (locale) => locale.toLowerCase() === normalized
  );
  if (exactMatch) {
    return exactMatch as SupportedLocale;
  }

  const language = normalized.split('-')[0];
  switch (language) {
    case 'da':
      return 'da';
    case 'fr':
      return 'fr-CA';
    case 'en':
      return DEFAULT_LOCALE;
    default:
      return DEFAULT_LOCALE;
  }
}

export function setupStaticTranslations(): void {
  updateLocale(
    resolveSupportedLocale(getOfficeDisplayLanguage() || navigator.language)
  );
}
